const mutations = {
    RESET_THESAURUS_FLAG(state) {
        state.isThesaurusLoaded = false;
    },
    SET_AUDIO_DATA(state, { audio, pronunciation }) {
        state.audioData = { audio, pronunciation };
    },
    SET_THESAURUS_HEADWORD(state, headword) {
        state.thesaurusHeadword = headword;
    },
    SET_THESAURUS(state, thesaurus) {
        state.thesaurus = JSON.parse(JSON.stringify(thesaurus));
        state.filteredThesaurus = JSON.parse(JSON.stringify(thesaurus));
        state.isThesaurusLoaded = true;
    },
    SET_SYNONYM_STUDIES(state, study) {
        state.study = JSON.parse(JSON.stringify(study));
    },
    SET_DEFAULT_FILTERS(state, obj) {
        const { pos, category } = obj;
        state.filters.pos.default.push(...new Set(pos.filter(pos => pos)));
        state.filters.category.default.push(...new Set(category.filter(cat => cat)));
    },
    SET_ACTIVE_FILTERS(state, obj) {
        state.filters[obj.filterType].active = obj.filters;
    },
    FILTER_THESAURUS(state) {
        state.filteredThesaurus = state.thesaurus
            .filter(synonym => {
                const { active } = state.filters.pos;
                return active.length ? active.includes(synonym.partOfSpeech) : true;
            })
            .filter(synonym => {
                const { active } = state.filters.category;
                const includeCommonFilter = active.includes("commonFilter");
                const includeUniqueFilter = active.includes("uniqueFilter");

                if (!active.length) {
                    return true;
                } else if (includeCommonFilter && includeUniqueFilter) {
                    if (active.length > 2) {
                        return active.includes(synonym.type);
                    }

                    return true;
                } else if (includeCommonFilter) {
                    if (active.length > 1) {
                        return active.includes(synonym.type) && synonym.word.common;
                    }

                    return synonym.word.common;
                } else if (includeUniqueFilter) {
                    if (active.length > 1) {
                        return active.includes(synonym.type) && !synonym.word.common;
                    }

                    return !synonym.word.common;
                }
                return active.includes(synonym.type);
            });
    },
    CLEAR_ACTIVE_FILTERS(state) {
        Object.keys(state.filters).map(filter => {
            state.filters[filter].active = [];
        });
        state.filteredThesaurus = JSON.parse(JSON.stringify(state.thesaurus));
    },
    TOGGLE_MOBILE_FILTER(state, opened) {
        state.isMobileFilterPanelOpened = opened;
    },
    SORT_AZ_THESAURUS(state) {
        state.filteredThesaurus.sort((a, b) => {
            if (a.word.slug > b.word.slug) {
                return 1;
            }
            if (a.word.slug < b.word.slug) {
                return -1;
            }
            return 0;
        });
        state.orderSelected = "a-z";
    },
    SORT_ZA_THESAURUS(state) {
        state.filteredThesaurus.sort((a, b) => {
            if (a.word.slug < b.word.slug) {
                return 1;
            }
            if (a.word.slug > b.word.slug) {
                return -1;
            }
            return 0;
        });
        state.orderSelected = "z-a";
    },
    SET_IS_SORTED(state, isSorted) {
        state.isSorted = isSorted;
    },
    SORT_BY_VOTES_THESAURUS(state) {
        state.filteredThesaurus.sort((a, b) => {
            if (b.upvotes === a.upvotes) {
                return a.downvotes - b.downvotes;
            }
            return b.upvotes - a.upvotes;
        });
        state.orderSelected = "votes";
    },
    SORT_BY_RELEVANCE(state) {
        state.filteredThesaurus.forEach(synonym => {
            synonym.sources.sort((a, b) => a.rank - b.rank);
        });
        state.filteredThesaurus.sort(
            (a, b) => a.sources[0].orderInSource - b.sources[0].orderInSource
        );
        state.orderSelected = "relevance";
    },
    SET_COPIED_SYNONYM(state, synonym = "") {
        state.isCopyToastVisible = !!synonym.relationId;
        // Need this condition to detect when CopyToast
        // dissappears. In that case, setting up a timeout
        if (synonym && synonym.relationId) {
            state.copiedSynonym = { ...synonym };
        } else {
            setTimeout(() => {
                state.copiedSynonym = { ...synonym };
            }, 75);
        }
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/ThesaurusFilter/mutations.js